import React from 'react'
import { FieldLabel } from '../form/index'
import StaffSearchSelect from './StaffSearchSelect'

const StaffSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={StaffSearchSelect} />
)

export default StaffSearchSelectField
